import { FormControl, FormGroup, Validators, AbstractControl } from "@angular/forms";
import { CompanySlotUpdate, RegisterParticipantRequest } from "@ent-regis/entregis-ts-angular";
import { appConst } from "src/app/constants/app-const";

export interface RegisterForm {
  participants: RegisterParticipantRequest[];
  slots: CompanySlotUpdate[];
}

export function buildParticipantFormBase(p: RegisterParticipantRequest, noneDietaryId?: number): FormGroup {
  return new FormGroup({
    firstName: new FormControl(p.firstName || ''),
    lastName: new FormControl(p.lastName || ''),
    email: new FormControl(p.email || ''),
    willReceiveEmail: new FormControl(p.willReceiveEmail != null ? p.willReceiveEmail : true),
    mobileNumber: new FormControl(p.mobileNumber || ''),
    jobTitle: new FormControl(p.jobTitle || ''),
    department: new FormControl(p.department || ''),
    isParticipant: new FormControl(p.isParticipant != null ? p.isParticipant : false),
    isAttendee: new FormControl(p.isAttendee != null ? p.isAttendee : false),
    isContact: new FormControl(p.isContact != null ? p.isContact : false),
    dietaryRequirementId: new FormControl(p.dietaryRequirementId || noneDietaryId),
    otherDietary: new FormControl(p.otherDietary || ''),
    extNumber: new FormControl(p.extNumber || ''),
  });
}

export function decorateParticipantFormForModal(
  form: FormGroup, 
  contactCount: number, 
  participantCount: number, 
  maxParticipant: number
): FormGroup {
  form.get('firstName').setValidators([Validators.required]);
  form.get('lastName').setValidators([Validators.required]);
  form.get('email').setValidators([Validators.required, Validators.pattern(appConst.emailPattern)]);
  form.get('willReceiveEmail').setValidators([Validators.required]);
  form.get('mobileNumber').setValidators([Validators.required]);
  form.get('jobTitle').setValidators([Validators.required]);
  form.setValidators(roleValidator);

  toggleContactControl(form, contactCount);
  toggleParticipantControls(form, participantCount, maxParticipant);

  form.updateValueAndValidity();
  return form;
}

function toggleContactControl(form: FormGroup, contactCount: number): void {
  const ctrl = form.get('isContact');
  if (!ctrl) return;

  const shouldDisable = contactCount > 0 && !ctrl.value;
  toggleControl(ctrl, shouldDisable);
}

function toggleParticipantControls(form: FormGroup, participantCount: number, maxParticipant: number): void {
  const isParticipantCtrl = form.get('isParticipant');
  const isAttendeeCtrl = form.get('isAttendee');

  if (!isParticipantCtrl || !isAttendeeCtrl) return;

  const isQuotaFull = participantCount >= maxParticipant;
  const isParticipantSelected = !!isParticipantCtrl.value;
  const isAttendeeSelected = !!isAttendeeCtrl.value;

  if (isParticipantSelected) {
    toggleControl(isParticipantCtrl, false);
    toggleControl(isAttendeeCtrl, true);
    return;
  }
  if (isAttendeeSelected) {
    toggleControl(isParticipantCtrl, true);
    toggleControl(isAttendeeCtrl, false);
    return;
  }
  if (isQuotaFull) {
    toggleControl(isParticipantCtrl, true);
    toggleControl(isAttendeeCtrl, true);
    return;
  }
  toggleControl(isParticipantCtrl, false);
  toggleControl(isAttendeeCtrl, false);
}

export function toggleControl(control: AbstractControl, disable: boolean): void {
  if (disable) {
    control.disable({ emitEvent: false });
  } else {
    control.enable({ emitEvent: false });
  }
}

export function roleValidator(group: FormGroup) {
    const isParticipant = group.get('isParticipant') && group.get('isParticipant').value;
    const isAttendee = group.get('isAttendee') && group.get('isAttendee').value;
    const isContact = group.get('isContact') && group.get('isContact').value;

    const selectedCount = [isParticipant, isAttendee, isContact].filter(Boolean).length;

    return selectedCount >= 1 ? null : { roleRequired: true };
  }